import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartContainer } from 'src/app/models/chart-container.model';
import { UserService } from 'src/app/services/user.service';
import { ChartsService } from 'src/app/services/charts.service';

@Component({
  selector: 'app-add-container-dialog',
  templateUrl: './add-container-dialog.component.html',
  styleUrls: ['./add-container-dialog.component.scss']
})
export class AddContainerDialogComponent implements OnInit {

  public containerForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<AddContainerDialogComponent>, @Inject(MAT_DIALOG_DATA) public container: ChartContainer,
    private chartsService: ChartsService, private userService: UserService) { }

  ngOnInit() {
    this.containerForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      description: new FormControl('', [Validators.required, Validators.maxLength(500), Validators.minLength(40)]),
    })

    this.dialogRef.updateSize("400px", "500px")
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.containerForm.controls[controlName].hasError(errorName);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public createContainer = (formValue) => {
    if (this.containerForm.valid) {
      this.exectueCreateContainer(formValue);
    }
  }

  private exectueCreateContainer = (formValue) => {
    let container = new ChartContainer();
    container.name = formValue.name;
    container.description = formValue.description;
    container.createdBy = this.userService.user.gmid;

    this.chartsService.createChartContainer(container).subscribe(
      res => {
        this.dialogRef.close(res);
      },
      err => {
        console.log('error creating chart container');
      })
  }

}